define('modules/base/models/base.model',[
    'client',
    'underscore',
    'backbone'
], function(Prospector, _, Backbone){
    var BaseModel = Backbone.Model.extend({
        base: '',
        errorMessage: '',
        debugName: 'BaseModel',
        debugState: false,
        modelStatus: 100,
        useLocalStorage: false,
        onlyUseLocalStorageOnPageLoad: false,
        onlyUseLocalStorageForFirstPull: false,
        baseService: 'prospector/v1',
        firstPull: true,
        initialize: function(attributes, options) {
            //this.bind("error", this.defaultErrorHandler);
        },
        urlRoot:function(){
            var baseSub = "login.relpro.com";
            if(window.utils.readCookie("specifiedHost") != null && window.utils.readCookie("specifiedHost") != "undefined"){
                baseSub = window.utils.readCookie("specifiedHost");
            }
            if(window.location.href.indexOf("http://") > -1){
                return 'http://' + baseSub + "/" + this.baseService + '/' + this.base;
            } else {
                return 'https://' + baseSub + "/" + this.baseService + '/' + this.base;
            }
            // return window.utils.makeUrl('prospector/v1/' + this.base);
        },
        isValid: function(){
            if(this.modelStatus == 100){
                return true;
            } else {
                this.set({error: undefined});
                return false;
            }
        },
        fetch: function(options) {
            if(this.useLocalStorage &&
                (
                    (
                        this.onlyUseLocalStorageForFirstPull &&
                        this.firstPull
                    )||
                    (
                        (
                            this.onlyUseLocalStorageOnPageLoad == false &&
                            this.onlyUseLocalStorageForFirstPull == false
                        )||
                        (
                            this.onlyUseLocalStorageOnPageLoad &&
                            window.firstLoad
                        )
                    )
                )
            ){
                var key = this.urlRoot();
                var func = $.proxy(function(attr){
                    if(attr != null){
                        this.set(attr);
                        var model = this;
                        var resp = attr;
                        if(options!= undefined && options.success){
                            model.once('sync', options.success);
                        }
                        model.trigger('sync', model, resp, options);
                        this.firstPull = false;
                    } else {
                        Backbone.Model.prototype.fetch.call(this, options);
                    }
                }, this);
                window.utils.readStorageObject(key)
                    .then(function(attr){
                        func(attr);
                    });
            } else {
                Backbone.Model.prototype.fetch.call(this, options);
            }
        },
        parse: function(response) {
            this.firstPull = false;
            if (response != null && typeof response.error != "undefined") {
                this.modelStatus = response.error.status;
                this.errorMessage = response.error.message + " [Error Code: " + response.error.status + "]";
                if(response.error.status != undefined && response.error.status == -300){
                    window.firstLoad = false;
                    window.app.trigger("sessionDone");
                } else if(response.error.status != undefined && response.error.status == -221){
                    window.firstLoad = false;
                    window.app.trigger("showAcceptedTerms");
                } else if(response.error.status != undefined && response.error.status == -220){
                    window.firstLoad = false;
                    window.app.trigger("mustResetPassword");
                } else if(response.error.status != undefined && (
                    response.error.status == -201 ||
                    response.error.status == -202 ||
                    (response.error.status < -205 && response.error.status > -210) ||
                    response.error.status == -212 ||
                    (response.error.status < -214 && response.error.status > -218)
                    )){
                    window.firstLoad = false;
                     window.app.trigger("lockToAccountInfo");
                }
            } else {
                this.modelStatus = 100;
                if(this.useLocalStorage){
                    var key = this.urlRoot();
                    var attr = window.utils.writeStorageObject(key, response);
                }
            }
            if(this.debugState){
                window.utils.output(this.debugName +": "+ JSON.stringify(response));
            }
            return response;
        },
        destroy: function(options) {
            if(options == undefined){
                options = {};
            }

            if (this.attributes) {
                // properly formats data for back-end to parse
                options.data = JSON.stringify(this.attributes);
            }
            // transform all delete requests to application/json
            options.contentType = 'application/json';


            options = options ? _.clone(options) : {};
            var destroy = function() {
                model.trigger('destroy', model, model.collection, options);
            };
            var model = this;
            var success = options.success;
            options.success = function(resp, status, xhr) {
                done = true;
                var serverAttrs = model.parse(resp);
                if (options.wait) serverAttrs = _.extend(attrs || {}, serverAttrs);
                if (!model.set(serverAttrs, options)) return false;
                if (success) success(model, resp, options);
                model.trigger('sync', model, resp, options);
            };
            if (this.isNew()) {
                options.success();
                return false;
            }
            var xhr = this.sync('delete', this, options);
            if (!options.wait) destroy();
            return xhr;
        }
    });
    return BaseModel;
});

